import { FC, ReactNode } from 'react'
import styles from './NumText.module.scss'
import cx from 'classnames'

interface NumTextItem {
	num: ReactNode
	text: ReactNode
	prefix?: ReactNode
}

interface Props {
	items: NumTextItem[]
	className?: string
}

export const NumText: FC<Props> = (props) => {
	return (
		<ul className={cx(styles.num_text, 'numtext_c', props.className)}>
			{props.items.map((item, index) => (
				<li
					key={index}
					className={cx(styles.item, 'numtext')}
				>
					<span className="text">{item.prefix}</span>
					<span className="num">{item.num}</span>
					<span className="text">{item.text}</span>
				</li>
			))}
		</ul>
	)
}
